import React, { useEffect, useState } from "react";
import DesktopHeader from "./desktop";
import MobileHeader from "./mobile";
import { useSettings } from "hooks/useStore";
import Overlay from "components/overlay";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";
import useIsSticky from "hooks/useIsSticky";
import Image from "components/image";
import clsx from "clsx/lite";
import ShoppingCart from "components/shopping-cart";
import DesktopSpecialLinks from "./desktop/special-links";

const NavBar = ({ logo, keepLogoLinked, children, justifyContent = "center" }) => (
	<nav className={`flex items-center justify-${justifyContent} px-4 md:px-10 border-b bg-white h-20`}>
		<div className="flex-1 flex justify-center">
			<Image image={{ ...logo, url: keepLogoLinked ? "/" : "" }} className="w-20 lg:w-24" />
		</div>
		{children}
	</nav>
);

const LogoOnlyHeader = ({ logo, keepLogoLinked }) => (
	<NavBar logo={logo} keepLogoLinked={keepLogoLinked} />
);

const MinimalHeader = ({ logo, keepLogoLinked }) => (
	<NavBar logo={logo} keepLogoLinked={keepLogoLinked} justifyContent="between">
		<div className="flex items-center justify-end">
			<ShoppingCart />
		</div>
	</NavBar>
);

const Header = ({ sliceContext, previewData, pageSettings }) => {
	const {
		hideHeaderNavigation = false, keepLogoLinked = false,
		hideHeaderExtraLinks = false, minimalHeader = false, embedHeader = false
	} = pageSettings || {};
	const { mobile, desktop, search } = previewData || sliceContext;
	const { isSearchOpen } = useSettings(["isSearchOpen"]);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.lg });
	const isSticky = useIsSticky({ isHeader: true, isMenuOpen });

	useEffect(() => {
		document.body.classList.toggle("overflow-hidden", (isMenuOpen && isMobile) || isSearchOpen);
	}, [isMenuOpen, isSearchOpen]);

	const showCompactHeader = minimalHeader && !hideHeaderNavigation;
	const isFullHeaderVisible = !minimalHeader && !hideHeaderNavigation;
	const desktopEmbedHeader = isSticky || isSearchOpen ? false : embedHeader;
	const mobileEmbedHeader = isSticky ? false : embedHeader;

	return (
		<>
			{isFullHeaderVisible &&
				<DesktopSpecialLinks hideHeaderExtraLinks={hideHeaderExtraLinks}
					contactInfo={desktop.contactInfo} embedHeader={embedHeader} />}
			<div className={
				clsx("transition-all duration-150 ease-out !z-[48] relative",
					isSticky && "sticky-element ",
					isSticky === false && "sticky-element-hidden",
					isMenuOpen && "!z-50 md:!z-[48]"
				)}
			>
				{hideHeaderNavigation &&
					<LogoOnlyHeader logo={desktop.logo} keepLogoLinked={keepLogoLinked} />}

				{showCompactHeader &&
					<MinimalHeader logo={desktop.logo} keepLogoLinked={keepLogoLinked} />}


				{isFullHeaderVisible && (
					<>
						{desktop && <DesktopHeader data={desktop} searchData={search} setIsMenuOpen={setIsMenuOpen} />}
						{desktop && <DesktopHeader data={desktop} searchData={search}
							setIsMenuOpen={setIsMenuOpen} embedHeader={desktopEmbedHeader} variation2 />}
						{mobile && <MobileHeader data={mobile} searchData={search} />}
						{mobile && <MobileHeader data={mobile} searchData={search} embedHeader={mobileEmbedHeader} variation2 />}
					</>
				)}
			</div>
			<Overlay show={isMenuOpen} />
		</>
	);
};

export default Header;